import Modal from 'react-bootstrap/Modal';

import { ModalButton } from '../../styles/StyledComponents';

const DeleteConfirmationModal = ({ show, closeHandler, actionHandler }) => {
    // ----- Actions
    const handleClose = () => {
        closeHandler();
    };

    const handleAction = () => {
        actionHandler();
    };

    // ----- Render
    return (
        <Modal show={show} backdrop='static' centered onHide={handleClose}>
            <Modal.Header className='fw-bold' closeButton>
                Mensaje de confirmación
            </Modal.Header>
            <Modal.Body>Desea cancelar?</Modal.Body>
            <Modal.Footer>
                <ModalButton className='cancel' onClick={handleClose}>
                    No
                </ModalButton>
                <ModalButton className='action' onClick={handleAction}>
                    Si
                </ModalButton>
            </Modal.Footer>
        </Modal>
    );
};

export default DeleteConfirmationModal;
